import { Drawer, styled } from '@mui/material';
import cn from 'classnames';
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router';
import { MOBILE_BREAKPOINT, NAV } from 'src/config-global';
import { useBreakpoints } from 'src/hooks/useBreakpoints';
import { useNavbarContext } from 'src/provider/NavbarContext';

type Props = {
  openNav: boolean;
  onCloseNav: VoidFunction;
  children: ReactNode;
};

const ActionsDrawerContainer = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  top: 0,
  bottom: 0,
  left: 0,
  height: '100%',
  zIndex: 1,
  pointerEvents: 'none',
  overflow: 'hidden',
  flexShrink: 0,
  borderRight: `1px solid ${theme.palette.divider}`,
  width: NAV.W_DASHBOARD_EXPANDED,
  transform: `translateX(-${NAV.W_DASHBOARD_EXPANDED}px)`,
  transition: 'transform 0.3s ease-in-out',
  '&.isHidden': {
    position: 'absolute',
    boxShadow: theme.shadows[8],
  },
  '&.isOpen': {
    pointerEvents: 'auto',
    transform: 'translateX(0)',
    height: '100%',
  },

  [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
    bottom: 0,
    left: 0,
  },
}));

export const ResponsiveVerticalNav = ({
  openNav,
  onCloseNav,
  children,
}: Props) => {
  const { pathname } = useLocation();

  const { upMobile } = useBreakpoints();

  const { hiddenNavBar } = useNavbarContext();

  // biome-ignore lint/correctness/useExhaustiveDependencies: Needs to update when pathname changes
  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  return (
    <>
      {upMobile ? (
        <ActionsDrawerContainer
          className={cn({
            isOpen: !hiddenNavBar || openNav,
            isHidden: hiddenNavBar,
          })}
          onMouseLeave={onCloseNav}
        >
          {children}
        </ActionsDrawerContainer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{ sx: { width: { xs: '85%', md: NAV.W_DASHBOARD } } }}
        >
          {children}
        </Drawer>
      )}
    </>
  );
};
